import { KeyValuePair } from "../../shared/models/models";

export interface IntegrationConnConfig<T> {
  isActive: boolean;
  connectionConfig: T;
}

export interface IntegrationConfig {
  integrationId: number;
  isActive: boolean;
  featuresConfig: IntegrationFeaturesConfig;
}

export interface ResponseConnectionStatus {
  name: string;
  data: IntegrationState;
}

export interface IntegrationStatus {
  integrationId: number;
  status: IntegrationState;
  integrationName: string;
  connectionStatus: { code: ConnectionStatus; errorDescription: string };
}

export enum IntegrationState {
  'online' = 0,
  'offline' = 1
}

export enum ConnectionStatus {
  'Ok' = 0,
  'NotOk' = 1
}

export interface IntegrationFeaturesConfig {
  companySegmentsField: string;
  companyLinkField: string;
  leadAssistedField: string;
  contactAssistedField: string;
  isSegmentByMa: boolean;
}

export interface IntegrationSettingsMarketo {
  ClientId: string;
  ClientSecret: string;
  Url: string;
}

export interface IntegrationSettingSalesforce {
  ClientId: string;
  ClientSecret: string;
}

export interface IntegrationSettingsMailchimp {
  ApiKey: string;
}

export interface IntegrationSettingsPardot {
  ClientId: string;
  ClientSecret: string;
  BusinessUnitId: string;
}

export interface IntegrationSettingsActon {
  User: string;
  Password: string;
}

export interface IntegrationSettingsHubspot {
  send_ip: number;
  send_page: number;
}

export interface IntegrationSettingsSlack { }

export interface IntegrationSettingsDemandBase { }

export interface LabelNamePair {
  label: string;
  name: string;
}

export type IntegrationSettingType = IntegrationSettingsMarketo |
  IntegrationSettingSalesforce |
  IntegrationSettingsMailchimp |
  IntegrationSettingsPardot |
  IntegrationSettingsActon |
  IntegrationSettingsHubspot |
  IntegrationSettingsSlack;


export interface LeadInformation {
  identified: boolean;
  leadLists: string[];
  properties: Record<string, unknown>[];
  maLeadId: number;
  provider: string;
}

export interface MaList {
  name: string;
  canPushLeads: boolean;
  id: string;
}

export interface MaField {
  name: string;
  label: string;
  description: string;
  fieldType: string;
  readOnly: boolean;
  length: number;
  isCollection: boolean;
  availableValues: KeyValuePair[];
  isTooManyValues: boolean;
}

export interface CrmCompaniesResponse {
  total: number;
  companies: CrmCompany[];
}

export interface CrmCompany {
  company: string;
  domain: string;
}

export interface CrmItemUpdateError {
  id: string;
  errorCode: string;
  message: string;
}
